<template>
    <v-select :filter="search" v-bind="[$props,$attrs]" v-on="$listeners">
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
        <template v-if="$attrs['loading']" #spinner>
            <b-spinner small class="mr-50" variant="primary" v-show="$attrs['loading']"></b-spinner>
        </template>
        <template v-if="$attrs['img']" #option="option">
            <div v-if="option[$attrs['img']]" class="option-image">
                <div class="option-image-wrapper">
                    <img v-image-error :src="option[$attrs['img']]">
                </div>
                {{option[$attrs.label]}}
            </div>
        </template>
        <template #no-options="{ search, searching }">
            <template v-if="searching">'<b>{{ search }}</b>' için bir sonuç bulunamadı.</template>
            <template v-else>Herhangi bir veri bulunamadı.</template>
        </template>
    </v-select>
</template>

<script>
import {BSpinner} from 'bootstrap-vue'
import Additional from '@/utilities/additional'
export default {
    components:{
        BSpinner,
    },
    inheritAttrs:false,
    methods:{
        search(options,search){
            if (!search) return options;
            
            const searchLower = Additional.ToEng(search).toLowerCase();
            const filtered = options.filter(o=> Additional.ToEng(o[this.$attrs['label']]).toLowerCase().includes(searchLower));
            
            return filtered.sort((a, b) => {
                const aLabel = Additional.ToEng(a[this.$attrs['label']]).toLowerCase();
                const bLabel = Additional.ToEng(b[this.$attrs['label']]).toLowerCase();
                const aStarts = aLabel.startsWith(searchLower);
                const bStarts = bLabel.startsWith(searchLower);
                
                if (aStarts && !bStarts) return -1;
                if (!aStarts && bStarts) return 1;
                return 0;
            });
        }
    }
}
</script>